import { render, staticRenderFns } from "./TemplateTwoEn.vue?vue&type=template&id=bd33e978&scoped=true&"
import script from "./TemplateTwoEn.vue?vue&type=script&lang=js&"
export * from "./TemplateTwoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd33e978",
  null
  
)

export default component.exports